import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { SharedModule } from "src/app/shared/shared.module";
import { DatumModule } from "src/app/shared/directives/datum";

import { HomePageRoutingModule } from "./home-routing.module";
import { HomePage } from "./home.page";
import { LayoutsModule } from "src/app/shared/components/layouts/layouts.module";
import { FooterModule } from "src/app/shared/components/footer/footer.module";
import { UpdateFlockPresaleAlertComponent } from "./update-flock-presale-vehicle/update-flock-presale-alert/update-flock-presale-alert.component";
import { UpdateFlockPresaleVehiclePage } from "./update-flock-presale-vehicle/update-flock-presale-vehicle.page";
import { VehicleFormModule } from "src/app/shared/components/vehicle-form/vehicle-form.module";
import { MyqqButtonModule } from "src/app/shared/components/button/button.module";
import { ModalDialogModule } from "src/app/shared/components/dialog-modal";
import { CeramicUpgradeComponent } from "./marketing-content/ceramic-upgrade/ceramic-upgrade.component";
import { MarketingContentComponent } from "./marketing-content/marketing-content.component";
import { LetDirective } from "@ngrx/component";
import { B2cComponent } from "./b2c-card/b2c-card.component";
import { StayAndSaveProgressComponent } from "src/app/shared/components/stay-and-save/stay-and-save-progress.component";
import { LandingPageModule } from "../landing/landing.module";

@NgModule({
  imports: [
    CommonModule,
    DatumModule,
    FooterModule,
    FormsModule,
    HomePageRoutingModule,
    LandingPageModule,
    LayoutsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    ModalDialogModule,
    MyqqButtonModule,
    SharedModule,
    VehicleFormModule,
    LetDirective,
    StayAndSaveProgressComponent,
  ],
  declarations: [
    HomePage,
    CeramicUpgradeComponent,
    UpdateFlockPresaleAlertComponent,
    UpdateFlockPresaleVehiclePage,
    MarketingContentComponent,
    B2cComponent,
  ],
})
export class HomePageModule {}
